export default __webpack_public_path__ + "static/media/risk-bars-high-light.3c24948d.svg";